const carouselItems = [
  {
    title: '暑期科幻狂欢季',
    desc: '星际穿越、外星文明、未来世界——精选50部高分科幻巨制，带你遨游浩瀚宇宙。从《星际迷航》到《沙丘》，经典与新作一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20movie%20collage%20with%20spaceships%20and%20galaxies%2C%20futuristic%20cityscape%2C%20dramatic%20neon%20lighting%2C%20cinematic%20composition%2C%20deep%20space%20nebula%20colors%2C%20professional%20film%20poster%20style&width=800&height=400&seq=carousel-1&orientation=landscape'
  },
  {
    title: '国产悬疑片大爆发',
    desc: '近年国产悬疑佳作频出，《迷雾追踪》《消失的她》《河边的错误》等豆瓣高分影片齐聚，反转不断、烧脑过瘾，悬疑迷不可错过的专题合集。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20noir%20atmosphere%20with%20dark%20alleys%20and%20rainy%20streets%2C%20detective%20silhouette%2C%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20suspenseful%20mood%2C%20film%20noir%20aesthetic&width=800&height=400&seq=carousel-2&orientation=landscape'
  },
  {
    title: '动作片硬核专场',
    desc: '肾上腺素狂飙！从《速度与激情》系列到《疾速追杀》，高能格斗、震撼追车、火爆枪战——献给每一个热爱动作片的你。',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20explosive%20scene%20with%20car%20chase%2C%20dramatic%20fire%20and%20smoke%20effects%2C%20intense%20urban%20setting%2C%20dynamic%20composition%2C%20cinematic%20wide%20shot%2C%20high%20energy%20atmosphere&width=800&height=400&seq=carousel-3&orientation=landscape'
  },
  {
    title: '温情治愈电影院',
    desc: '累了就来看一部治愈电影吧。《触不可及》《海蒂和爷爷》《菊次郎的夏天》——温暖人心的经典之作，让你在光影中找到内心的平静与感动。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20heartfelt%20movie%20scene%20with%20golden%20sunset%20lighting%2C%20peaceful%20countryside%20landscape%2C%20gentle%20and%20nostalgic%20atmosphere%2C%20soft%20focus%2C%20emotional%20cinematography%2C%20cozy%20and%20comforting%20vibe&width=800&height=400&seq=carousel-4&orientation=landscape'
  },
  {
    title: '经典老片修复计划',
    desc: '《教父》《肖申克的救赎》《霸王别姬》等数百部影史经典4K修复版陆续上线。重温那些改变电影史的伟大作品，画质焕新，感动不变。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20reel%20and%20projector%20with%20warm%20golden%20light%2C%20old%20Hollywood%20aesthetic%2C%20nostalgic%20cinema%20atmosphere%2C%20film%20strips%20and%20vintage%20camera%2C%20elegant%20retro%20composition&width=800&height=400&seq=carousel-5&orientation=landscape'
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            精选专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            精心策划的主题片单，发现电影的全新维度
          </p>
        </div>
        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col md:flex-row bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full md:w-[320px] lg:w-[380px] flex-shrink-0 aspect-[2/1] md:aspect-auto overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm md:text-base leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}